/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
import * as models from './models';

export interface LDCLPBPPublicApiModelsPricingMortgageMortgagePricingResponse {
    

    pricingResultId?: string;

    planNumber?: number;

    planDescription?: string;

    consumerDescription?: string;

    planType?: LDCLPBPPublicApiModelsPricingMortgageMortgagePricingResponse.PlanTypeEnum;

    planAttributes?: LDCLPBPPublicApiModelsPricingMortgageMortgagePricingResponse.PlanAttributesEnum;

    loanDisclosureType?: LDCLPBPPublicApiModelsPricingMortgageMortgagePricingResponse.LoanDisclosureTypeEnum;

    underwritingType?: LDCLPBPPublicApiModelsPricingMortgageMortgagePricingResponse.UnderwritingTypeEnum;

    isEligible?: boolean;

    termMonths?: number;

    feeCategory?: number;

    feeCategoryDesc?: string;

    rateTable?: string;

    rateSheet?: string;

    adjustmentList?: Array<models.LDCLPBPPublicApiModelsPricingMortgagePriceAdjustment>;

    armFixedPeriod?: number;

    armAdjustmentPeriod?: number;

    resultDetails?: Array<models.LDCLPBPPublicApiModelsPricingMortgageMortgagePricingResultDetails>;

    pricingError?: string;
}
export namespace LDCLPBPPublicApiModelsPricingMortgageMortgagePricingResponse {

    export enum PlanTypeEnum { 
        None = <any> 'None',
        ConventionalFixedRate = <any> 'ConventionalFixedRate',
        AdjustableRate = <any> 'AdjustableRate',
        GrowingEquity = <any> 'GrowingEquity',
        UniversalArm = <any> 'UniversalArm',
        GraduatedPayment = <any> 'GraduatedPayment',
        BIWeekly = <any> 'BIWeekly',
        Construction = <any> 'Construction',
        FhaGraduatedPayment = <any> 'FhaGraduatedPayment',
        FhaFixedRate = <any> 'FhaFixedRate',
        FhaAdjustableRate = <any> 'FhaAdjustableRate',
        FhaGrowingEquity = <any> 'FhaGrowingEquity',
        VAGraduatedPayment = <any> 'VAGraduatedPayment',
        VAFixedRate = <any> 'VAFixedRate',
        VAAdjustableRate = <any> 'VAAdjustableRate',
        HELOCFixedRate = <any> 'HELOCFixedRate',
        HELOCAdjustableRate = <any> 'HELOCAdjustableRate',
        RHSFixedRate = <any> 'RHSFixedRate',
    }

    export enum PlanAttributesEnum { 
        None = <any> 'None',
        FHA = <any> 'FHA',
        VA = <any> 'VA',
        Conventional = <any> 'Conventional',
        HARP = <any> 'HARP',
        Renovation = <any> 'Renovation',
        InterestOnly = <any> 'InterestOnly',
        MCC = <any> 'MCC',
        DownPaymentAssistance = <any> 'DownPaymentAssistance',
        CommunityLending = <any> 'CommunityLending',
        BrokeredOut = <any> 'BrokeredOut',
        Bond = <any> 'Bond',
        FixedRate = <any> 'FixedRate',
        AdjustableRate = <any> 'AdjustableRate',
        HELOC = <any> 'HELOC',
        Streamline = <any> 'Streamline',
        CES = <any> 'CES',
        USDA = <any> 'USDA',
        NonConforming = <any> 'NonConforming',
    }

    export enum LoanDisclosureTypeEnum { 
        None = <any> 'None',
        FixedRate = <any> 'FixedRate',
        AdjustableRateMortgage = <any> 'AdjustableRateMortgage',
        GrowingEquityMortgage = <any> 'GrowingEquityMortgage',
        UniversalArm = <any> 'UniversalArm',
        GraduatedPaymentMortgage = <any> 'GraduatedPaymentMortgage',
        BIWeekly = <any> 'BIWeekly',
        Construction = <any> 'Construction',
        RegulationZ = <any> 'RegulationZ',
        FhaGraduatedPaymentMortgage = <any> 'FhaGraduatedPaymentMortgage',
        FhaFixedRate = <any> 'FhaFixedRate',
        FhaAdjustableRateMortgage = <any> 'FhaAdjustableRateMortgage',
        FhaGrowingEquityMortgage = <any> 'FhaGrowingEquityMortgage',
        VAGraduatedPaymentMortgage = <any> 'VAGraduatedPaymentMortgage',
        VAFixedRate = <any> 'VAFixedRate',
        VAAdjustableRateMortgage = <any> 'VAAdjustableRateMortgage',
        HELOCFixed = <any> 'HELOCFixed',
        HELOCARM = <any> 'HELOCARM',
        RHSFixedRateMortgage = <any> 'RHSFixedRateMortgage',
    }

    export enum UnderwritingTypeEnum { 
        Unspecified = <any> 'Unspecified',
        Manual = <any> 'Manual',
        DU = <any> 'DU',
        LoanProductAdvisor = <any> 'LoanProductAdvisor',
        GUS = <any> 'GUS',
        DecisionSelect = <any> 'DecisionSelect',
    }
}
